import urls from "../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../utils/service";

export const updatePassword = async (passwordData: any) => {
  try {
    const callParams = await getCallParams("PUT", passwordData);
    const response = await makeCall(urls.updatePassword, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
